import { create } from "zustand";
import { persist } from "zustand/middleware";
import { ZUSTAND_KEY_UNIQUE } from "@/app/lib/constants";

type AutocompleteTenantState = {
   selectedTenantId: number;
   hasHydrated: boolean;
   setSelectedTenantId: (id: number) => void;
   setHasHydrated: (hasHydrated: boolean) => void;
};

export const useAutocompleteTenantStore = create<AutocompleteTenantState>()(
   persist(
      (set) => ({
         selectedTenantId: 0, // default is 0 (All)
         hasHydrated: false,
         setSelectedTenantId: (id: number) => set({ selectedTenantId: id }),
         setHasHydrated: (hasHydrated: boolean) => set({ hasHydrated })
      }),
      {
         name: ZUSTAND_KEY_UNIQUE.AUTOCOMPLETE_TENANT,
         partialize: (state) => ({ selectedTenantId: state.selectedTenantId }),
         onRehydrateStorage: () => (state) => {
            state?.setHasHydrated(true);
         }
      }
   )
);
